const translations = {
  about: 'Umbes TOP3',
  appName: 'TOP3',
  data: 'Data',
  tasks: 'Ülesanded',
  'tasks.create_title': 'Loo uus ülesanne',
  'task.removed': 'Task eemaldati',
  logout: 'Logi välja',
  password: 'Parool',
  email: 'E-post',
  login: 'Logi sisse',
  loginError: 'E-post või salasõna on vale',
  pleaseWait: 'Palun oota...',
  loggedOut: 'Sa oled edukalt välja logitud süsteem!',
  monday: 'Esmaspäev',
  tuesday: 'Teisipäev',
  wednesday: 'Kolmapäev',
  thursday: 'Neljapäev',
  friday: 'Reede',
  saturday: 'Saturday',
  sunday: 'Sunday',
  header: 'Ülesanne',
  type: 'Tüüp',
  typeActivity: 'Activity',
  typeBoard: 'Töötajad / Management',
  typeDevelopment: 'Strateegiline areng',
  task: 'Ülesanne',
  plannedResult: 'Eesmärk',
  achievedResult: 'Tulemus',
  rating: 'Hinnang',
  ratingMet: 'Rahuldav',
  ratingNotMet: 'Mitterahuldav',
  ratingAverage: 'Keskmine',
  save: 'Salvesta',
  cancel: 'Loobu',
  date: 'Kuupäev',
  weekday0: 'Esmaspäev',
  weekday1: 'Teisipäev',
  weekday2: 'Kolmapäev',
  weekday3: 'Neljapäev',
  weekday4: 'Reede',
  weekday5: 'Saturday',
  weekday6: 'Sunday',
  week: 'Nädala',
  user: 'Töötaja',
  'user.filter': 'Otsi töötaja ...',
  noResults: 'Ei leitud',
  comments: 'Kommentaarid',
  delete: 'Eemalda',
  confirmTaskDelete: 'Oled sa kindel, et soovid kustutada selle ülesande?',
  myTasks: 'Minu ülesanded',
  sessionExpired: 'Sessioon aegus. Palun logi uuesti.',
  attachFile: 'Manusta fail',
  confirmCommentDelete: 'Oled sa kindel, et soovid eemaldada selle kommentaari?',
  commentEmail: 'Kommentaar saadeti e-posti teel',
  required: 'Selle välja täitmine on kohustuslik',
  'comment.tooltip': 'Lisa kommentaar',
  'groups.title': 'Grupid',
  'group.title': 'Grupp',
  'groups.edit_title': 'Muuda rühma',
  'groups.create_title': 'Loo rühm',
  'groups.delete_title': 'Eemalda grupp',
  'groups.id': 'Ei',
  'groups.name': 'Nimi',
  'groups.ownerId': 'Manager',
  'groups.changeOwner': 'Vali juht ...',
  'groups.find': 'Otsi rühm ...',
  'group.members': 'Liikmed',
  'group.guests': 'Külalised',
  'group.addMember': 'Lisa liige',
  'group.addGuest': 'Lisa külaline',
  'group.noMembers': 'Keegi lisatakse',
  'group.confirmDelete': 'Oled sa kindel, et soovid kustutada selle grupiga?',
  'users.title': 'Kasutajad',
  'user.title': 'Kasutaja',
  'user.profile': 'Minu profiil',
  'user.modify.title': 'Edit kasutaja',
  'users.create.tooltip': 'Loo kasutaja',
  'users.delete_title': 'Eemalda kasutaja',
  'user.created': 'Naudotojas sukurtas',
  'user.updated': 'Naudotojas pakeistas',
  'user.removed': 'Naudotojas pašalintas',
  'users.id': 'Ei',
  'user.name': 'Nimi',
  'user.surname': 'Perekonnanimi',
  'user.role': 'Role',
  'user.role.ADMIN': 'Administrator',
  'user.role.USER': 'Kasutaja',
  'user.role.undefined': 'Määramata',
  'user.email': 'E-post',
  'user.email.unique': 'E-post peab olema unikaalne',
  'user.username': 'Kasutajanimi',
  'user.username.unique': 'Kasutajanimi peab olema unikaalne',
  'user.password': 'Kasutaja parool',
  'user.members': 'Liikmesriigid rühmades',
  'user.guests': 'Klientide rühmades',
  'user.addGroup': 'Lisa grupp',
  'user.noMembers': 'Keegi lisatakse',
  'user.delete.confirm': 'Oled sa kindel, et soovid kustutada selle kasutaja?',
  'user.language.select': 'Keel',
  'user.language.EN': 'English',
  'user.language.ES': 'Ispano',
  'user.language.PL': 'Polskie',
  'user.language.RU': 'Русский',
  'user.language.LT': 'Lietuvių',
  'user.language.LV': 'Latviešu',
  'user.language.EE': 'Eesti',
  'user.view.edit': 'Redaguoti naudotoją',
  'user.role.select': 'Rolė',
  'user.save.tooltip': 'Išsaugoti naudotoją',
  'user.cancel.modify.tooltip': 'Atšaukti',
  'user.password.change.save.tooltip': 'Išsaugoti naują slaptažodį',
  'user.password.change.cancel.tooltip': 'Atšaukti',
  'user.view.change.password': 'Muuda salasõna',
  'user.password.change.title': 'Parooli muutmine',
  'user.password.old': 'Vana parool',
  'user.password.new1': 'Uus salasõna',
  'user.password.new2': 'Korrake uut parooli',
  'user.password.change.mismatch': 'Paroolid ei sobitamine',
  'about.title': 'Umbes TOP3',
  'about.tagline': 'Sellele nupule siis alla kirjeldus TOP3 süsteem',
  'about.action': 'Lae alla',
  'about.text': 'Me ootame küsimustele ja tähelepanekud meie süsteemis '
    + '<a href="mailto:pagalba@axis.lt">pagalba@axis.lt</a> .',
  'user.password.changed': 'Parooli muutmine.',
  'user.password.change.failed': 'Muutmine ebaõnnestus parool. Arvestades parooli oli incorect.',
  dashboard: 'Grafikas',
  'dashboard.generate': 'Generuoti',
  'dashboard.saveAsImage': 'Siųstis',
  'dashboard.exportToExcel': 'Exportuoti į Excel',
  'dashboard.dataZoom': 'Priartinti',
  'dashboard.dataZoomReset': 'Gražinti praeitą vaizdą',
  'dashboard.restore': 'Atstatyti pradinį vaizdą',
  'dashboard.noData': 'Nėra duomenų',
  'dashboard.data.title': 'Grafikas',
  'dashboard.data.dateFrom': 'Laikotarpis nuo (imtinai)',
  'dashboard.data.dateTo': 'Laikotarpis iki (imtinai)',
  'dashboard.data.unit': 'Matavimo vienetas',
  'dashboard.data.unit.WEIGHT': 'Svoris, t',
  'dashboard.data.unit.VOLUME': 'Tūris, m3',
  'dashboard.data.unit.VOLUME_AT_15C': 'Tūris prie 15°C, m3',
  'dashboard.data.exportToExcel': 'Excel',
  'dashboard.data.reportdate': 'Laikas',
  'dashboard.data.official': 'Buhalterija',
  'dashboard.data.fact': 'Faktinis',
  'dashboard.data.factFrom': 'Fakto paklaida nuo',
  'dashboard.data.factTo': 'Paklaidos dydis',
  'dashboard.data.factPart5': 'Talpykla5',
  'dashboard.data.factPart6': 'Talpykla6',
  'dashboard.data.diff': 'Skirtumas',
  'dashboard.data.counter': 'Skaitiklis',
  'dashboard.data.counterDiff': 'Skaitiklio skirtumas',
  // product form generic
  products: 'Produktai',
  'products.title': 'Produktai',
  'product.title': 'Produktas',
  'product.delete.confirm': 'Ar tikrai norite pašalinti produktą',
  'product.updated': 'Produktas atnaujintas',
  'product.created': 'Produktas sukurtas',
  'product.filter': 'Ieškoti produkto...',
  'product.save.tooltip': 'Išsaugoti produktą',
  'product.modify.title': 'Produktas',
  'product.cancel.modify.tooltip': 'Atšaukti redagavimą',
  'product.create.title': 'Produkto kūrimas',
  'product.cancel.create.tooltip': 'Atšaukti kūrimą',
  'product.create.tooltip': 'Kurti produktą',
  // product form specific
  'product.type': 'Produktas',
  'product.description': 'Aprašymas',
  'product.shortDescription': 'Trumpas aprašymas',
  'product.classificator': 'Klasifikatorius',
  'product.tarrifGroupCode': 'Tarifinė grupė',
  'product.materialType': 'Produkto rūšis',
  'product.name.unique': 'Produkto pavadinimas turi būti unikalus',

  // driver form generic
  drivers: 'Vairuotojai',
  'drivers.title': 'Vairuotojai',
  'driver.title': 'Vairuotojas',
  'driver.create.tooltip': 'Kurti Vairuotoją',
  'driver.updated': 'Vairuotojas atnaujintas',
  'driver.created': 'Vairuotojas sukurtas',
  'driver.removed': 'Vairuotojas pašalintas',
  'driver.filter': 'Ieškoti vairuotojo...',
  'driver.save.tooltip': 'Išsaugoti vairuotoją',
  'driver.modify.title': 'Vairuotojo redagavimas',
  'driver.create.title': 'Vairuotojo kūrimas',
  'driver.cancel.modify.tooltip': 'Atšaukti redagavimą',
  'driver.cancel.create.tooltip': 'Atšaukti kūrimą',
  'driver.delete.confirm': 'Ar tikrai norite pašalinti vairuotoją',
  // driver form specific
  'driver.fullName': 'Vairuotojo vardas pavardė',
  'driver.adrNo': 'Vairuotojo ADR numeris',
  'driver.adrDate': 'Vairuotojo ADR galiojimo data',

  // company form generic
  companies: 'Įmonės',
  'companies.title': 'Įmonės',
  'company.title': 'Įmonė',
  'company.create.tooltip': 'Kurti Įmonę',
  'company.updated': 'Įmonė atnaujinta',
  'company.created': 'Įmonė sukurta',
  'company.removed': 'Įmonė pašalinta',
  'company.filter': 'Ieškoti įmonės ...',
  'company.save.tooltip': 'Išsaugoti įmonę',
  'company.modify.title': 'Įmonės redagavimas',
  'company.create.title': 'Įmonės kūrimas',
  'company.cancel.modify.tooltip': 'Atšaukti redagavimą',
  'company.cancel.create.tooltip': 'Atšaukti kūrimą',
  'company.delete.confirm': 'Ar tikrai norite pašalinti įmonę ?',
  // company form specific
  'company.name': 'Pavadinimas',
  'company.address': 'Adresas',
  'company.vatCode': 'PVM kodas',
  'company.country': 'Valstybė',
  'company.companyCode': 'Įmonės kodas',
  'company.exciseWhNo': 'Akcizinio sandėlio Nr.',
  'company.additionalInformation': 'Papildoma informacija',
  'company.companyCode.unique': 'Įmonės kodas turi būti unikalus',
  'company.code.unique': 'Įmonės kodas turi būti unikalus',
  'country.select': 'Valstybė',
  'company.whClient': 'Sandėlio klientas',

  // tank form generic
  tanks: 'Talpyklos',
  'tanks.title': 'Talpyklos',
  'tank.create.tooltip': 'Sukurti talpyklą',
  'tank.updated': 'Talpykla atnaujinta',
  'tank.created': 'Talpykla sukurta',
  'tank.removed': 'Talpykla pašalinta',
  'tank.filter': 'Ieškoti talpyklos...',
  'tank.save.tooltip': 'Išsaugoti talpyklą',
  'tank.modify.title': 'Talpyklos redagavimas',
  'tank.create.title': 'Talpyklos kūrimas',
  'tank.cancel.modify.tooltip': 'Atšaukti redagavimą',
  'tank.cancel.create.tooltip': 'Atšaukti kūrimą',
  'tank.delete.confirm': 'Ar tikrai norite pašalinti talpyklą ?',
  // tank form specific
  'tank.name': 'Talpyklos pavadinimas',
  'tank.capacity.ltr': 'Talpa litrais (l)',
  'tank.capacity.kg': 'Talpa kilogramais (kg)',
  'tank.material': 'Produktas',
  'tank.name.unique': 'Talpyklos pavadinimas turi būti unikalus',
  'material.select': 'Produktas',

  // transport form generic
  transports: 'Transporto priemonės',
  'transports.title': 'Transporto priemonės',
  'transport.title': 'Transporto priemonė',
  'transport.create.tooltip': 'Kurti Transporto priemonę',
  'transport.updated': 'transporto priemonė atnaujinta',
  'transport.created': 'Transporto priemonė sukurta',
  'transport.removed': 'Transporto priemonė pašalinta',
  'transport.filter': 'Ieškoti transporto priemonės',
  'transport.save.tooltip': 'Saugoti transporto priemonę',
  'transport.edit.title': 'Transporto priemonės redagavimas',
  'transport.create.title': 'Transporto priemonės kūrimas',
  'transport.cancel.modify.tooltip': 'Atšaukti',
  'transport.delete.confirm': 'Ar tikrai norite pašalinti transporto priemonę',
  // transport form specific
  'transportType.select': 'Tipas',
  'transport.name.unique': 'Transporto priemonės numeris turi būti unikalus',
  'transports.description': 'Apibūdinimas',
  'transports.brand': 'Markė',
  'transports.model': 'Modelis',
  'transports.adrNo': 'ADR numeris',
  'transports.adrDate': 'ADR galiojimo data',
  'transports.segments': 'Segmentų talpos',
  'transports.segmentNo': 'Segmento Nr.',
  'transports.capacityLtr': 'Segmento talpa, l',
  'transport.segment.add': 'Pridėti segmentą',
  'transport.segment.remove': 'Pašalinti segmentą',
  'transport.identificationNo': 'Numeris',
};

export default translations;